import { useQuery } from "@apollo/client/react";
import GET_INVOICE_READER_TEMPLATE from "../../queries/invoiceReaderTemplates/getInvoiceReaderTemplate";
import type { InvoiceReaderTemplateResponseModel } from "../../../models/ClientInvoiceReaderTemplateModel";

export const useInvoiceReaderTemplate = (
  clientIdentifier?: string,
  templateId?: string,
) => {
  const { data, error, loading, refetch } = useQuery<{
    invoiceReaderTemplate: InvoiceReaderTemplateResponseModel;
  }>(GET_INVOICE_READER_TEMPLATE, {
    skip: !clientIdentifier || !templateId,
    variables: {
      clientIdentifier: clientIdentifier,
      id: templateId,
    },
  });
  return { template: data?.invoiceReaderTemplate, error, loading, refetch };
};
